export const enGB = {
  brand: 'MKProjectLab',
  concept: 'Concept demo',
  title: 'Home decorating quote calculator',
  subtitle: 'See how a service business can turn room details into a clearer, more complete enquiry.',
  intro: 'This example uses illustrative rates and simplified rules. It is not a quotation from a real decorating company.',
  marketLabel: 'Market',
  marketUK: 'United Kingdom',
  marketPL: 'Poland',
  languageLabel: 'Language',
  start: 'Start estimate',
  step: 'Step',
  of: 'of',
  back: 'Back',
  next: 'Continue',
  calculate: 'Calculate estimate',
  reset: 'Reset calculator',
  resetConfirm: 'Reset all entered information?',
  addRoom: 'Add another room',
  duplicateRoom: 'Duplicate room',
  removeRoom: 'Remove',
  room: 'Room',
  rooms: 'Rooms',
  project: 'Project',
  dimensions: 'Dimensions',
  surfaces: 'Surfaces',
  condition: 'Condition',
  finish: 'Finish',
  result: 'Estimate',
  projectIntro: 'Choose the market and region used for the illustrative price configuration.',
  propertyType: 'Property type',
  propertyHouse: 'House',
  propertyFlat: 'Flat / apartment',
  propertyCommercial: 'Small commercial space',
  region: 'Region',
  regionStandardUK: 'Standard UK',
  regionLondon: 'London & South East',
  regionStandardPL: 'Poland — standard',
  regionWarsaw: 'Warsaw & surrounding area',
  travel: 'Travel',
  travelLocal: 'Local',
  travelExtended: 'Extended travel',
  travelOutside: 'Outside service area',
  roomType: 'Room type',
  customName: 'Custom room name',
  typeLivingRoom: 'Living room',
  typeBedroom: 'Bedroom',
  typeKitchen: 'Kitchen',
  typeBathroom: 'Bathroom',
  typeHallway: 'Hallway',
  typeOffice: 'Office',
  typeOther: 'Other',
  length: 'Length',
  width: 'Width',
  height: 'Height',
  metres: 'metres',
  doors: 'Doors',
  windows: 'Windows',
  radiators: 'Radiators',
  dimensionsHelp: 'Use internal room measurements. The model assumes a simple rectangular room.',
  paintWalls: 'Paint walls',
  paintCeiling: 'Paint ceiling',
  paintSkirting: 'Paint skirting boards',
  paintedDoors: 'Doors and frames to paint',
  paintedRadiators: 'Radiators to paint',
  colourChange: 'Colour change',
  colourSimilar: 'Similar colour',
  colourNoticeable: 'Noticeable colour change',
  colourDarkToLight: 'Very dark to light',
  conditionLabel: 'Surface condition',
  conditionGood: 'Good',
  conditionGoodHelp: 'Stable, clean surfaces with typical preparation only.',
  conditionMinor: 'Minor repairs',
  conditionMinorHelp: 'Small holes, hairline cracks and local filling.',
  conditionNoticeable: 'Noticeable repairs',
  conditionNoticeableHelp: 'Multiple defects, flaking paint or more extensive preparation.',
  conditionNewPlaster: 'New plaster',
  conditionNewPlasterHelp: 'Requires suitable priming or a preparation coat.',
  conditionSpecialist: 'Specialist assessment',
  conditionSpecialistHelp: 'Moisture, mould, active staining or unstable surfaces.',
  wallpaperRemoval: 'Wallpaper removal',
  stainBlocking: 'Stain-blocking treatment',
  highCeiling: 'Height above 2.8 m',
  difficultAccess: 'Difficult access',
  furnished: 'Heavily furnished / occupied room',
  risksTitle: 'Conditions requiring a manual assessment',
  moistureOrMould: 'Moisture, mould or active water staining',
  unstableSurface: 'Unstable plaster or surface separation',
  scaffoldingRequired: 'Scaffolding or specialist access required',
  specialistFinish: 'Special decorative finish',
  fullReplastering: 'Full stripping or replastering',
  exteriorWork: 'Exterior work',
  materialStandard: 'Material standard',
  materialStandardValue: 'Standard trade paint',
  materialPremium: 'Premium paint',
  summaryTitle: 'Review your project',
  summarySubtitle: 'Check the room details before calculating the illustrative range.',
  estimateTitle: 'Illustrative estimate',
  estimateRange: 'Estimated range',
  estimateCentral: 'Central calculation',
  manualTitle: 'Manual assessment required',
  manualBody: 'The project includes conditions that should not be priced automatically. The collected details are still summarised below.',
  disclaimer: 'This is an illustrative estimate based on the information provided. It is not a binding quotation. Final pricing may require photographs, a site visit and confirmation of the surface condition.',
  conceptLabel: 'Concept demo by MKProjectLab',
  conceptBody: 'A practical example of how a service company could collect better enquiries and apply its own pricing rules.',
  cta: 'Discuss a calculator for your business',
  ctaNote: 'No details are sent from this demo. The button opens MKProjectLab contact email.',
  surfacesSummary: 'Selected work',
  geometrySummary: 'Calculated quantities',
  wallsArea: 'Walls',
  ceilingArea: 'Ceiling',
  skirtingLength: 'Skirting',
  noAutomaticPrice: 'No automatic price',
  required: 'This field is required.',
  invalidNumber: 'Enter a number within the allowed range.',
  selectSurface: 'Select at least one surface or item to paint.',
  paintedCount: 'The number to paint cannot exceed the number in the room.',
  maximumRooms: 'A maximum of five rooms is supported in this concept demo.',
  errorsHeading: 'Please correct the highlighted fields.',
  reasonLabels: {
    tooManyRooms: 'More than five rooms',
    noRooms: 'No rooms added',
    outsideServiceArea: 'Outside the illustrative service area',
    specialistAssessment: 'Specialist surface assessment selected',
    heightOverFour: 'Room height above 4 m',
    moistureOrMould: 'Moisture or mould',
    unstableSurface: 'Unstable surface',
    scaffoldingRequired: 'Scaffolding required',
    specialistFinish: 'Special decorative finish',
    fullReplastering: 'Full stripping or replastering',
    exteriorWork: 'Exterior work'
  }
} as const;
